/**
 * The console's own numbers, in one place — nothing here lives as a magic
 * number at a call site. The API's ceilings (rate limits, body cap, window
 * lengths) are server settings in `apps/ops-api/src/config.ts` and
 * `apps/ops-api/src/ratelimit.ts`; this file holds the client's side of the
 * same conversation: how it asks again, and how long it is willing to wait.
 */

/** How the console asks again when an answer does not come. */
export const RETRY = {
  /** Attempts beyond the first for transient failures (network, 5xx). */
  transient: 2,
  /** A 429 is retried once, inside the window the server names in Retry-After. */
  rateLimited: 1,
  /** A wait longer than this surfaces as an error instead — the ceiling is a real refusal, not a blip. */
  maxWaitMs: 15_000,
  /** First backoff for transient failures, doubling per attempt. */
  baseDelayMs: 500,
} as const
